<template>
  <div class="trading-container">
    <trading-slider
      :routers="TradingRouter"
      v-bind="$attrs"
      :company-click-handler="companyClickHandler"
      :hideLeft="hideLeft"
      :isZnl="isZnl"
      @route-change="
        routeName => {
          $emit('route-change', routeName);
        }
      "
    ></trading-slider>
  </div>
</template>
<script>
import TradingSlider from './components/TradingSlider';
import TradingRouter from './router/index';
import TradingStore from './store';
import { httpPost, httpGet } from './assets/scripts/http';
import './components/common/GridCellRender';
import './assets/style/index.scss';
export default {
  name: 'trading',
  components: {
    TradingSlider
  },
  props: {
    token: String,
    companyClickHandler: Function,
    defaultActive: {
      type: String,
      default: 'InventoryPricing'
    },
    permissions: {
      type: Object,
      default() {
        return {
          // Home: true,
          InventoryPricing: false, //库存定价
          ReceivedInquiry: true, // 收到的询价
          SalesOrder: true, // 销售订单
          Statement: true, // 对账单
          // SalesChannels: false, //销售管道
          // ChannelAnalysis: false, // 管道分析
          PricingStrategy: false, // 定价设置
          OutgoingInquiry: true, // 发出的询价
          PurchaseOrder: false, // 旧采购订单
          PurchaseOrderList: true, // 新采购订单
          PurchaseOrderListDetails: false, //  新采购订单详情
          MyBom: true, // BOM列表
          Information: true //基本信息
        };
      }
    },
    hideLeft: {
      type: Boolean,
      default: false
    },
    isZnl: Boolean
  },
  async created() {
    if (this.token) {
      this.store.commit('setToken', this.token);
      await this.PostMeShareSetAsync();
      await this.setPermissions();
      this.getShareStepPlanListAsync();
    }

    this.store.commit('setLayout', { hideleft: this.hideLeft });
  },
  watch: {
    token(token) {
      if (token) {
        this.store.commit('setToken', this.token);
        this.PostMeShareSetAsync();
      }
    }
  },
  methods: {
    getShareStepPlanListAsync() {
      // 获取阶梯价方案，触发创建默认方案
      httpGet('shareStock/getShareStepPlanListAsync');
    },
    async PostMeShareSetAsync() {
      // 2019.5.28需求： 本公司没有开启共享时，用户不能访问(销售管道、管道分析、库存定价、定价设置)模块
      await httpPost('shareStock/PostMeShareSetAsync').then(res => {
        if (res.Code === 0) {
          // const SalesChannels = this.TradingRouter.find(
          //   item => item.name === 'SalesChannels'
          // );
          // if (SalesChannels) {
          //   SalesChannels.meta.hide = !res.Data;
          //   this.permissions.SalesChannels = true;
          // }

          // const ChannelAnalysis = this.TradingRouter.find(
          //   item => item.name === 'ChannelAnalysis'
          // );
          // if (ChannelAnalysis) {
          //   ChannelAnalysis.meta.hide = !res.Data;
          //   this.permissions.ChannelAnalysis = true;
          // }

          const InventoryPricing = this.TradingRouter.find(
            item => item.name === 'InventoryPricing'
          );
          if (InventoryPricing) {
            InventoryPricing.meta.hide = !res.Data;
            this.permissions.InventoryPricing = true;
          }

          const PricingStrategy = this.TradingRouter.find(
            item => item.name === 'PricingStrategy'
          );
          if (PricingStrategy) {
            PricingStrategy.meta.hide = !res.Data;
            this.permissions.PricingStrategy = true;
          }
        }
      });
      // 2019.9.18需求： 用户在Bom匹配白名单时开启MyBom模块，否则关闭
      // httpGet('bomanalysis/getIsOpenBomAsync').then(res => {
      //   if (res.Code === 0) {
      //     const MyBom = this.TradingRouter.find(item => item.name === 'MyBom');
      //     if (MyBom) {
      //       MyBom.meta.hide = !res.Data;
      //     }
      //   }
      // });
    },
    async setPermissions() {
      for (let index = 0; index < this.TradingRouter.length; index++) {
        if (
          this.TradingRouter[index].name !== 'TradingCenterIndex' &&
          this.TradingRouter[index].name !== 'TradingCenterOutgoing' &&
          this.TradingRouter[index].name !== 'BaseInformation' &&
          !this.permissions[this.TradingRouter[index].name]
        ) {
          this.TradingRouter.splice(index, 1);
          index--;
        }
      }

      // 默认路由有权限时正常使用，无权限时使用允许的第一个路由
      if (this.permissions[this.defaultActive]) {
        this.store.commit('setRoute', { name: this.defaultActive });
      } else {
        for (const key in this.permissions) {
          if (this.permissions.hasOwnProperty(key)) {
            if (this.permissions[key]) {
              this.store.commit('setRoute', { name: key });
              break;
            }
          }
        }
      }
    }
  },
  data() {
    return {
      store: TradingStore,
      TradingRouter
    };
  }
};
</script>
<style lang="scss">
@import './assets/style/var.scss';
@import './assets/style/znlui.scss';

.trading-container {
  height: 100%;
  min-width: 1240px;
  .HoverCommon {
    cursor: pointer;
    &:hover {
      color: #4a90e2;
      font-weight: bold;
    }
  }
  .HoverA {
    &:hover {
      text-decoration: underline;
    }
  }
  .ag-cell {
    text-align: center;
  }
  // 搜索样式对齐
  .c-tradingcenter-search-header-fl {
    display: flex;
    align-items: center;
    height: 100%;
    float: left;
    .el-select__caret {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
.znl-dialog__wrapper {
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
.c-tradingcenter-search-header {
  height: 50px;
  line-height: 50px;
}
.c-ReceivedInquiry {
  .znl-Timeline-Trading {
    font-size: 12px;
    line-height: 26px;
    .znl-Timeline-left {
      color: $--fontcolor-dark-2;
    }
    .znl-Timeline-center {
      padding: 0 5px 0 10px;
      color: #000;
    }
    .znl-Timeline-right {
      color: #ee7700;
      font-weight: bold;
    }
  }
}
.el-popover {
  max-height: 600px;
  overflow-y: auto;
}
.el-date-editor .el-range-input,
.el-date-editor .el-range-separator {
  font-size: 12px;
}
.companyBusinesscard-popper {
  padding: 5px 10px;
  font-size: 12px;
  overflow: hidden;
  .companyBusinesscard {
    .title {
      font-weight: bold;
      color: #333;
      border-bottom: 1px solid #e6e6e6;
      line-height: 30px;
    }
    .row {
      line-height: 24px;
      a {
        color: #28c;
      }
    }
  }
}
.vito-grid-right-menu {
  z-index: 99999;
}
.GridRenderCellLog-popper {
  font-size: 12px;
  line-height: 26px;
  overflow-x: hidden;
  max-height: 400px;
  .GridRenderCellLog-row {
    .time {
      padding-right: 10px;
      width: 126px;
    }
    .Remark {
      padding-left: 15px;
      border-left: 1px solid #e6e6e6;
      position: relative;
      max-width: 120px;
      .OperatorRole {
        position: absolute;
        top: 0;
        left: -5px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        top: 50%;
        transform: translateY(-50%);
        box-sizing: border-box;
        border: 1px solid #ee7700;
        &.system {
          background-color: #ee7700;
        }
        &.nosystem {
          background-color: #fff;
        }
      }
    }
  }
  .znl-button {
    margin-right: 10px;
  }
}
.el-select-dropdown .el-scrollbar .el-select-dropdown__wrap {
  &.el-scrollbar__wrap {
    margin-bottom: 0 !important;
  }
}
</style>
